'use strict';

class MarketplaceSelect2Component extends MarketplaceFormComponent {

    constructor(selector, options = {}) {
        super(selector);
        this.options = options;
        this.init();
    }

    init() {
        if (!this.element.data('select2')) {
            this.element.select2(this.options);
        }
    }


    getSelectedData() {
        return this.element.select4('data')[0] || null;
    }

    triggerChange() {
        this.element.trigger('change');
        return this;
    }


    addOption(value, text, data = {}) {
        const option = new Option(text, value, false, false);


        for (const key in data) {
            if (data.hasOwnProperty(key)) {
                $(option).attr(`data-${key}`, data[key]);
            }
        }

        this.element.append(option);
        return this;
    }


    clearOptions() {
        this.element.empty();
        return this;
    }
}